import {createApi} from '@reduxjs/toolkit/query/react';
import {AxiosRequestHeaders} from 'axios';

import httpBaseQuery from '../../../shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from '../../../shared/config/model/urls';
import IPortIncident from '../model/PortIncident/IPortIncident';
import {ISummaryPortIncident} from '../model/PortIncident/ISummaryPortIncident';
import IHydraResponse from '../../../shared/api/model/HydraResponse';
import IPagination from '../../../shared/api/model/IPagination';
import ICollectionParams from '../../../shared/api/model/ICollectionParams';
import {paginationAdapter} from '../../../shared/api/paginationHelper';
import {providesListUuid} from '../../../shared/api/rtk-query/RTKQueryHelper';
import {buildQuery} from '../../../shared/api/query';

export const portIncidentAPI = createApi({
    reducerPath: 'portIncidentAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['PortIncident', 'SummaryPortIncident'],
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getPortIncidents: build.query<IPagination<IPortIncident>, ICollectionParams>({
            query: ({page, sort, filters, limit}) => ({
                path: buildQuery(ApiUrls.PORT_INCIDENTS(page, sort, filters, limit)),
                headers: {Accept: 'application/ld+json'} as unknown as AxiosRequestHeaders,
            }),
            providesTags: (result) => providesListUuid(result?.items, 'PortIncident'),
            transformResponse(
                rawResult: IHydraResponse<IPortIncident>,
            ): Promise<IPagination<IPortIncident>> | IPagination<IPortIncident> {
                return paginationAdapter(rawResult);
            },
        }),
        getPortIncident: build.query<IPortIncident, string>({
            query: (uuid) => ({
                path: ApiUrls.PORT_INCIDENT(uuid),
            }),
            providesTags: (result, error, uuid) => [{ type: 'PortIncident', id: uuid }],
        }),
        getSummaryPortIncident: build.query<ISummaryPortIncident, void>({
            query: () => ({
                path: ApiUrls.SUMMARY_PORT_INCIDENTS,
            }),
            providesTags: ['SummaryPortIncident'],
        }),
    }),
});
